import { render, staticRenderFns } from "./ScrapingSettingsContent.vue?vue&type=template&id=fa6095be&scoped=true"
import script from "./ScrapingSettingsContent.vue?vue&type=script&lang=js"
export * from "./ScrapingSettingsContent.vue?vue&type=script&lang=js"
import style0 from "./ScrapingSettingsContent.vue?vue&type=style&index=0&id=fa6095be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6095be",
  null
  
)

export default component.exports